import React from 'react';
import styled from 'styled-components';

const Account = ({ userName }: any) => {
  return (
    <Wrapper>
      <p>Hello, Diana</p>
    </Wrapper>
  );
};

const Wrapper = styled.main`
  background: ${({ theme }: any) => theme.colors.GrayWhite};
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export default Account;
